module.exports = __webpack_public_path__ + "static/media/dtac-accelerate-logo.60c9e1b2.png";